import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { hideCouponPopup } from "@app/store/app/appActions"
import { RootState } from "@app/types"

// Components
import Popup, { PopupContent } from "@modules/popup/Popup"
import { Coupons } from "@ng-mw/shared-react-components/coupons"

const CouponPopup = () => {
    const dispatch = useDispatch<any>()
    const isOpen = useSelector((state: RootState) => state.app.couponPopup.visible)

    return (
        <Popup
            onClose={() => dispatch(hideCouponPopup())}
            isOpen={isOpen}
            isSimple={false}
            title="Dine kuponger"
            isFullscreenPopup
        >
            <PopupContent>
                <Coupons
                    headingLevel={2}
                    introText=""
                    // TODO verify
                    contextBackground="primary"
                />
            </PopupContent>
        </Popup>
    )
}

export default CouponPopup
